module.exports = __webpack_public_path__ + "media/svg/pin-459a0a7d.svg";